import { Button } from '../ui/Button';

type Props = {
  versions?: { label: string; author: string; date: string; source: 'ai' | 'human' }[];
};

export function VersionControlPanel({
  versions = [
    { label: 'v4 — Current draft', author: 'AI Copilot', date: '2h ago', source: 'ai' },
    { label: 'v3 — Approved', author: 'Sarah K.', date: '1d ago', source: 'human' },
    { label: 'v2 — Review rejected', author: 'AI Copilot', date: '3d ago', source: 'ai' },
    { label: 'v1 — Initial sync', author: 'System', date: '7d ago', source: 'human' },
  ],
}: Props) {
  return (
    <div className="space-y-2">
      {versions.map((v) => (
        <div key={v.label} className="flex items-center justify-between rounded-lg border border-slate-200 p-3 text-sm dark:border-slate-700">
          <div>
            <p className="font-medium">{v.label}</p>
            <p className="text-xs text-slate-500">{v.author} · {v.date}</p>
          </div>
          <div className="flex gap-1">
            <Button variant="secondary" size="sm">Compare</Button>
            {v.source === 'ai' && (
              <span className="rounded bg-ai-100 px-1.5 py-0.5 text-xs text-ai-700 dark:bg-ai-950 dark:text-ai-300">AI</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
